import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import BaseOverride from 'Views/Page/Content/Templates/BaseOverride';
import Content from './Content/Content';

const CIPDocumentReviewTemplate = ({
  resource,
}) => {
  return (
    <WizardStepWrapperTemplate
      metaOverrideSet={BaseOverride}
      resource={resource}
      layout={Content}
      showMobileSideNavigationMenu
    />
  );
};

CIPDocumentReviewTemplate.defaultProps = {
};

CIPDocumentReviewTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default CIPDocumentReviewTemplate;
